import React from 'react';
import { DollarSign, Package, Calendar, TrendingUp } from 'lucide-react';
import Icon from '../../../components/AppIcon';


export default function PerformanceKPICards({ kpis }) {
  const kpiConfig = [
    {
      title: 'Valeur Stock Total',
      value: `${kpis?.totalStockValue?.toFixed(2) || 0} €`,
      icon: DollarSign,
      color: 'green',
      bgColor: 'bg-green-50',
      textColor: 'text-green-600',
      borderColor: 'border-green-200'
    },
    {
      title: 'Consommation Mensuelle',
      value: `${kpis?.monthlyConsumption || 0} unités`,
      icon: Package,
      color: 'blue',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600',
      borderColor: 'border-blue-200'
    },
    {
      title: 'Jours de Stock Moyen',
      value: `${kpis?.averageDaysOfSupply || 0} jours`,
      icon: Calendar,
      color: 'purple',
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-600',
      borderColor: 'border-purple-200'
    },
    {
      title: 'Coût Moyen/Unité',
      value: `${kpis?.avgCostPerUnit?.toFixed(2) || 0} €`,
      icon: TrendingUp,
      color: 'orange',
      bgColor: 'bg-orange-50',
      textColor: 'text-orange-600',
      borderColor: 'border-orange-200',
      change: kpis?.revenueChange,
      changeLabel: 'vs période précédente'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {kpiConfig?.map((kpi, index) => {
        const Icon = kpi?.icon;
        const hasPositiveChange = kpi?.change && kpi?.change > 0;
        const hasNegativeChange = kpi?.change && kpi?.change < 0;
        
        return (
          <div 
            key={index}
            className={`bg-white rounded-lg shadow-sm border ${kpi?.borderColor} p-6 hover:shadow-md transition-shadow`}
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`p-3 rounded-lg ${kpi?.bgColor}`}>
                <Icon size={24} className={kpi?.textColor} />
              </div>
              {kpi?.change !== undefined && (
                <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                  hasPositiveChange ? 'bg-green-100 text-green-700' : hasNegativeChange ?'bg-red-100 text-red-700': 'bg-gray-100 text-gray-700'
                }`}>
                  {hasPositiveChange && '+'}
                  {kpi?.change?.toFixed(1)}%
                </div>
              )}
            </div>
            <h3 className="text-sm text-gray-600 mb-2">{kpi?.title}</h3>
            <p className="text-2xl font-bold text-gray-900">{kpi?.value}</p>
            {kpi?.changeLabel && (
              <p className="text-xs text-gray-500 mt-1">{kpi?.changeLabel}</p>
            )}
          </div>
        );
      })}
    </div>
  );
}